import { Component, ElementRef, Input } from '@angular/core';

/**
 * The "i" next to a Status label (mockup .property-status-help / .orders-status-help): hover or
 * focus shows what each inspection status means. Used on the Overview and the Inspections list.
 * [fixed]: placed against the window, for a header inside a table that scrolls sideways (the
 * mockup's .orders-status-tooltip is position: fixed for the same reason).
 */
@Component({
    selector: 'app-status-definitions',
    template: `
        <span class="sd-wrap" (mouseenter)="place()" (focusin)="place()">
            <button type="button" class="sd-help" aria-label="Status definitions" [attr.aria-describedby]="id">i</button>
            <span class="sd-tooltip" role="tooltip" [id]="id" [class.sd-fixed]="fixed"
                [style.top.px]="fixed ? top : null" [style.left.px]="fixed ? left : null">
                <ul>
                    <li *ngFor="let s of statuses"><strong>{{s.name}}:</strong> {{s.text}}</li>
                </ul>
            </span>
        </span>
    `,
    styles: [`
        .sd-wrap { position: relative; display: inline-flex; align-items: center; vertical-align: middle; }
        .sd-help { display: inline-grid; place-items: center; width: 18px; height: 18px; padding: 0; border: 1px solid #aeb9ca;
            border-radius: 50%; color: var(--im-muted, #61738d); background: transparent; font-family: inherit;
            font-size: 11px; font-weight: 800; line-height: 1; cursor: help; }
        .sd-help:focus-visible { outline: 3px solid #ffcf66; outline-offset: 3px; }
        .sd-tooltip { position: absolute; left: 0; top: calc(100% + 8px); z-index: 60; width: min(360px, calc(100vw - 64px));
            padding: 12px 14px; border-radius: 8px; color: #fff; background: #17284a; box-shadow: 0 8px 24px #0b244733;
            font-size: 14px; font-weight: 400; line-height: 1.5; text-align: left; text-transform: none; letter-spacing: 0;
            white-space: normal; opacity: 0; visibility: hidden; pointer-events: none; }
        .sd-tooltip.sd-fixed { position: fixed; z-index: 150; width: min(360px, calc(100vw - 32px)); }
        .sd-tooltip ul { margin: 0; padding-left: 18px; }
        .sd-tooltip li + li { margin-top: 8px; }
        .sd-tooltip strong { color: #fff; font-weight: 750; }
        .sd-wrap:hover .sd-tooltip, .sd-wrap:focus-within .sd-tooltip { opacity: 1; visibility: visible; }
    `]
})
export class StatusDefinitionsComponent {
    private static next = 0;
    @Input() fixed = false;
    top = 0;
    left = 0;
    readonly id = 'statusDefinitions' + (++StatusDefinitionsComponent.next);
    readonly statuses = [
        { name: 'Intake', text: 'In the process of being scheduled' },
        { name: 'Inspection', text: 'Scheduled, in progress, or waiting for the inspector to complete' },
        { name: 'Work', text: 'Inspection complete and any repairs are ready to schedule' },
        { name: 'Complete', text: 'All inspection and repair work is finished' },
        { name: 'Cancelled', text: 'Inspection has been cancelled' },
        { name: 'Deleted', text: 'Record has been marked as deleted' },
    ];

    constructor(private el: ElementRef) { }

    // Below the "i", kept inside the window.
    place() {
        if (!this.fixed) {
            return;
        }
        const rect = (this.el.nativeElement as HTMLElement).getBoundingClientRect();
        const width = Math.min(360, window.innerWidth - 32);
        this.top = rect.bottom + 8;
        this.left = Math.max(16, Math.min(rect.left, window.innerWidth - width - 16));
    }
}
